import React from 'react';

class Footer extends React.Component {

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light fixed-bottom" id="appFooter">
        <div className="collapse navbar-collapse container text-secondary">
          <ul className="navbar-nav pl-5">
            <li className="nav-item">
            </li>
          </ul>
                <ul className="navbar-nav pr-5">
                <li className="nav-item active  hideonsmall">
                      <span>v1.0.32</span>
                  </li>
            <li className="nav-item active">
              <span><a href="/SEC_Payment_Portal_Privacy_Policy.pdf">Privacy</a></span>
            </li>
            <li className="nav-item">
              <span><a href="/SEC_Portal_TOU.pdf">Terms and Conditions</a></span>
            </li>
            <li className="nav-item">
              <span><a href="mailto:epay_help.us@schindler.com">Contact Us</a></span>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default Footer
